import Box from 'components/shared/Box'
import Icon from 'components/shared/Icon'
import Button from 'components/shared/Button'
import { Label } from './styles'
import { DefaultTheme } from 'styled-components'

interface NumberPickerProps {
    minValue?: number
    maxValue?: number
    value: number
    handleAdd: () => void
    handleSubtract: () => void
    isDisabled?: boolean
    theme?: DefaultTheme
    testIdPrefix?: string
}

const NumberPicker = ({
    handleAdd,
    handleSubtract,
    value = 0,
    minValue = 0,
    maxValue,
    isDisabled,
    theme,
    testIdPrefix,
}: NumberPickerProps) => {
    const hasDarkMode = theme?.mode === 'dark'

    return (
        <Box direction="row" align="center" gap={4}>
            <Button
                variant="borderPrimary"
                hasArrow={false}
                isIconOnly={true}
                onClick={() => handleSubtract()}
                isDisabled={isDisabled || value === minValue}
                testId={`${
                    testIdPrefix ? `${testIdPrefix}-` : ''
                }counter-button-decrease`}
            >
                <Icon variant="minus" />
            </Button>
            <Label
                as="span"
                variant="heading3"
                align="center"
                color={hasDarkMode ? 'grayscale_200' : undefined}
            >
                {value}
            </Label>
            <Button
                variant="primary"
                hasArrow={false}
                isIconOnly={true}
                onClick={() => handleAdd()}
                isDisabled={isDisabled || value === maxValue}
                testId={`${
                    testIdPrefix && `${testIdPrefix}-`
                }counter-button-increase`}
            >
                <Icon variant="plus" />
            </Button>
        </Box>
    )
}

export default NumberPicker
